import UpdateRoundIcon from '@rsuite/icons/UpdateRound';
import {Tooltip, Whisper} from 'rsuite';
import './FirmwareUpdateIndicator.scss';

type FirmwareUpdateIndicatorProps = {
  visible?: boolean;
};

const FirmwareUpdateIndicator = ({visible = false}: FirmwareUpdateIndicatorProps) => {
  if (!visible) {
    return null;
  }

  return (
    <Whisper
      placement="top"
      trigger="hover"
      speaker={<Tooltip>Доступна новая версия прошивки</Tooltip>}
    >
      <span
        className="firmware-update-indicator"
        role="img"
        aria-label="Доступна новая версия прошивки"
        tabIndex={0}
      >
        <UpdateRoundIcon className="firmware-update-indicator__icon"/>
      </span>
    </Whisper>
  );
};

export default FirmwareUpdateIndicator;
